<template>
    <v-navigation-drawer
        id="core-navigation-drawer"
        v-model="drawer"
        :dark="barColor !== 'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'"
        :expand-on-hover="$isDesktop() ? expandOnHover : false"
        :right="$vuetify.rtl" src="/img/sidebar-1.jpg"
        mobile-break-point="960"
        app
        width="260"
        v-bind="$attrs"
        style="display: flex;height: 100%;">
        <template v-slot:img="props">
            <v-img :gradient="`to bottom, ${barColor}`" v-bind="props" />
        </template>

        <v-list-item two-line>
            <v-list-item-content>
                <v-list-item-title class="text-uppercase font-weight-regular display-2">
                    <span class="logo-mini">{{ $t('sc') }}</span>
                    <span class="logo-normal">{{ $t('sc2') }}</span>
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-divider class="mb-1" />

        <v-list dense nav>
            <base-item-group :item="profile" />
        </v-list>

        <v-divider class="mb-2" />

        <v-list expand nav style="padding-bottom:70px;">
            <!-- Style cascading bug  -->
            <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
            <div />

            <template v-for="(item, i) in computedItems">
                <base-item-group
                    v-if="item.children"
                    :key="`group-${i}`"
                    :item="item">
                    <!--  -->
                </base-item-group>

                <base-item
                    v-else
                    :key="`item-${i}`"
                    :item="item" />
            </template>

            <!-- Style cascading bug  -->
            <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
            <div />
        </v-list>
        <v-app-bar v-if="!$isDesktop()" bottom app fixed clipped-left height="80" style="background-color:#424242 !important">
            <div class="font-weight-light pt-md-0 text-center">
                &copy; 2020-2023 <a :href="CONF_CLIENT_URL" target="_blank" style="color:white">{{ CONF_CLIENT_URL_WRITTEN }}</a> - All rights reserved, made with
                <v-icon size="18">
                    mdi-heart
                </v-icon>
                for a better journey. ({{ CONF_REVISIONS_NUMBER }} - {{ CONF_SCHEDULER_VERSION }}, {{ CONF_VERSION_NUMBER }})
            </div>
        </v-app-bar>
    </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'; // Utilities
import {
        CONF_VERSION_NUMBER,
        CONF_REVISIONS_NUMBER,
        CONF_SCHEDULER_VERSION,
        CONF_CLIENT_URL_WRITTEN,
        CONF_CLIENT_URL
    } from '@/config';


    export default {
        name: 'DashboardCoreDrawer',

        /* >>> *************************************************************** / /* Props */
        props: {

            expandOnHover: {
                type: Boolean,
                default: false
            }

        }, // eof props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({
            CONF_VERSION_NUMBER: CONF_VERSION_NUMBER,
            CONF_REVISIONS_NUMBER: CONF_REVISIONS_NUMBER,
            CONF_SCHEDULER_VERSION: CONF_SCHEDULER_VERSION,
            CONF_CLIENT_URL_WRITTEN: CONF_CLIENT_URL_WRITTEN,
            CONF_CLIENT_URL: CONF_CLIENT_URL,
            items: [
                {
                    icon: 'mdi-view-dashboard',
                    title: 'dashboard',
                    to: '/'
                },
                {
                    group: '/flights',
                    icon: 'mdi-airplane-takeoff',
                    title: 'flights',

                    children: [
                        {
                            title: 'Flights',
                            to: 'flights',
                            grant: 'ANYTHING'
                        },
                        {
                            title: 'Blocktimes',
                            to: 'blocktimes',
                            grant: 'ANYTHING'
                        },
                        {
                            title: 'Airports',
                            to: 'airports',
                            grant: 'ANYTHING'
                        },
                        {
                            title: 'Slotmanagement',
                            to: 'slotmanagement',
                            grant: 'ADMIN'
                        }
                    ]
                }
            ]
        }),  // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            /*******************************************************************
            * mapGetters{}
            *
            * Desc:
            * Note:
            *
            */
            ...mapGetters([
                'get_Shared_isUserAllowedToUse',
                'get_shared_Drawer'
			]), // eof mapGetters{}

            // [WATCHHOW] .. state Objects get mapped ..
            ...mapState({
                barImage: state => state.shared.barImage,
                barColor: state => state.shared.barColor
            }),

            /*******************************************************************
            * drawer{}
            *
            * Desc:
            * Note:
            *
            */
            drawer: {
                get() {

                    return this.get_shared_Drawer;
                },
                set(val) {
                    this.actn_set_Drawer(val);
                }
            }, // eof drawer{}

            /*******************************************************************
            * computedItems{}
            *
            * Desc:
            * Note:
            *
            */
            computedItems () {

                return this.items.map(this.mapItem);
            }, // eof computedItems{}

            /*******************************************************************
            * profile{}
            *
            * Desc:
            * Note:
            *
            */
            profile () {
                return {
                    avatar: true,
                    group: '',
                    title: this.$t('avatar'),
                    children: [
                        {
                            href: '',
                            title: this.$t('my-profile')
                        },
                        {
                            to: '',
                            title: this.$t('edit-profile')
                        },
                        {
                            to: '',
                            title: this.$t('settings')
                        }
                    ]
                };
            } // eof profile{}

        }, // eof computed{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Watch */
        watch: {

            '$vuetify.breakpoint.smAndDown' (val) {
                this.$emit('update:expandOnHover', !val);
            }

        }, // eof watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

                /*******************************************************************
                * mapActions{}
                *
                * Desc:
                * Note:
                *
                */
                ...mapActions([
                    'actn_set_Drawer'
                ]), // eof mapActions()

                /*******************************************************************
                * profile{}
                *
                * Desc:
                * Note:
                *
                */
                mapItem(item) {

                    const me = this;

                    return {
                        ...item,
                        children: item.children
                            ? item.children.filter(child =>
                                me.get_Shared_isUserAllowedToUse(child.grant))
                                    .map(me.mapItem)
                            : undefined,
                        title: me.$t(item.title)
                    };

                } // eof mapItem()

        } // eof methods()

    };
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    &.v-navigation-drawer--mini-variant
      .v-list-item
        justify-content: flex-start !important

      .v-list-group--sub-group
        display: block !important

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>

<style scoped>
    .v-application .logo-mini {
        float: left;
        width: 30px;
        text-align: center;
        margin-left: 7px;
        margin-right: 30px;
    }

    .v-navigation-drawer {
        -webkit-box-shadow: none;
        box-shadow: none;
    }
</style>
